import { URLS } from 'api/constants';
import { IQuestion } from 'constants/types';
import { useLazyQuery } from 'hooks/useQuery';
import { useMutation } from 'hooks/useMutation';
import { apiGet, apiRequest } from 'lib/api/client';
import { PaginationResponse } from 'lib/api/types';

interface QuestionsRequest {
  page?: number;
  limit?: number;
  parentId?: string;
}

interface CreateQuestionRequest {
  image?: File;
  message: string;
  title: string;
  category?: string;
  replyId?: string;
  parent: string | null;
}

export const useLazyQuestionsQuery = () =>
  useLazyQuery<PaginationResponse<IQuestion>, QuestionsRequest>(
    ({ page, limit, parentId }) =>
      apiGet<PaginationResponse<IQuestion>>(URLS.QUESTIONS, {
        page,
        limit,
        parent_id: parentId,
      })
  );

export const useCreateQuestionMutation = () =>
  useMutation<CreateQuestionRequest, IQuestion>(
    ({ title, message, category, parent, image, replyId }) => {
      const formData = new FormData();
      formData.append('message', message);
      formData.append('title', title);

      if (parent) {
        formData.append('parent', parent);
      }

      if (replyId) {
        formData.append('reply_id', replyId);
      }

      if (image) {
        formData.append('image', image);
      }

      if (category) {
        formData.append('category', category);
      }

      return apiRequest<IQuestion>(URLS.QUESTIONS, {
        method: 'POST',
        auth: true,
        body: formData,
      });
    }
  );
